import Vue from 'vue'
import Router from 'vue-router'
import Meetings from './views/Meetings'
import Meeting from './views/Meeting'
import Members from './views/Members'

Vue.use(Router)

export default new Router({
	base: process.env.BASE_URL,
	linkActiveClass: 'active',
	mode: "history",
	routes: [
		{
			path: '/',
			name: 'meetings',
			component: Meetings
		},
		{
			path: '/meeting/:meeting_id?',
			name: 'meeting',
			component: Meeting
		},
		{
			path: '/members/:member?',
			name: 'members',
			component: Members
		}
	]
})
